import { useCountriesQuery } from '~~/domains/graphql';

export function usePhoneFromReferential() {
  const { result: countries } = useCountriesQuery();

  function getAlpha2CodeFromPrefix(prefix: string, alpha2Code?: string) {
    const possibleCountries =
      countries.value?.countries.filter(country =>
        country.callingCodes?.some(callingCode => callingCode === prefix),
      ) || [];

    if (!possibleCountries.length) {
      return prefix;
    }

    if (possibleCountries.length === 1) {
      return possibleCountries[0].alpha2Code;
    }

    if (possibleCountries.some(country => country.alpha2Code === alpha2Code)) {
      return alpha2Code;
    }

    return possibleCountries[0].alpha2Code;
  }

  function getPrefixFromAlpha2Code(alpha2Code: string) {
    const country = countries.value?.countries.find(
      country => country.alpha2Code === alpha2Code,
    );

    if (!country) {
      return alpha2Code;
    }

    return country.callingCodes?.[0] || alpha2Code;
  }

  return {
    getAlpha2CodeFromPrefix,
    getPrefixFromAlpha2Code,
  };
}
